import AppSettingsService from '@/services/app-settings.service'

const state = {
  settings: null
}

const mutations = {
  SET (state, payload) {
    state.settings = payload
  }
}

const actions = {
  fetch: async ({commit, state}, payload) => {
    payload = payload || {force: false}

    if(state.settings && !payload.force)
      return state.settings
    
    return AppSettingsService.getSettingsForSponsorPanel().then(data => {
      commit('SET', data)
      return data
    })
  },
  sync: ({ commit, state, dispatch}, data) => {
    return AppSettingsService.updateSponsorSettings(data).then(x => {
      dispatch('fetch', {force: true})
    })
  }
}

const getters = {
  settings: (state, getters) => {
    return state.settings
  },
  iranValidityPrice: state => {
    return (state.settings || {}).iranValidityPrice
  }  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
